import React from 'react'
import moment from 'moment'
import { Popconfirm, Tooltip, message } from 'antd'
import { Link } from 'react-router-dom'
import { deleteShippingBox } from '../../../../services/api/apiShippingCarrier'
import { canViewStoreName as checkStoreName } from '../../../../services/StorageServices'

function SettingBoxesRow(props) {
    const { item, reset } = props
    const canViewStoreName = checkStoreName()
    const {
        shipping_carriers,
        type,
        box_name,
        boxes_data,
        created_at,
        updated_at,
        _id
    } = { ...item }

    const shippingLevelCode = {
        50: 'First Class',
        60: 'Priority'
    }

    const checkData = (data) => {
        const { allow, disallow } = { ...data }
        if ((!allow || allow.length === 0) && (!disallow || disallow.length === 0)) {
            return 'All'
        } else {
            return <div>
                {allow.length > 0 &&
                    <span>{allow.join(', ').toString()}</span>
                }
                {disallow.length > 0 &&
                    <span className='text-danger'>{disallow.join(', ').toString()}</span>
                }
            </div>
        }
    }

    const onDelete = async (boxId) => {
        try {
            const { data, success, message: mess } = await deleteShippingBox(boxId)
            if (!success) {
                throw new Error(mess)
            }
            message.success(`Delete successed!!!`)
            reset()
        } catch (error) {
            const { response } = error || {}
            const { status, data: errorData = {} } = response || {}
            message.error(errorData.message || error.message)
        }
    }

    return (
        <>
            {type === 'combination' &&
                <tr>
                    <td>
                        <span className='font-weight-bold'>
                            {shipping_carriers && shipping_carriers.length > 0 ?
                                shipping_carriers.join(', ').toString()
                                : '-'
                            }
                        </span>
                    </td>
                    <td><span className="text-capitalize">{type || '-'}</span> box</td>
                    <td>{box_name || '-'}</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>{updated_at ? moment(updated_at).format('HH:mm DD/MM/YYYY') : '-'}</td>
                    <td>
                        <Link to={`/setting-boxes/${_id}`}>
                            <Tooltip title={`Edit`} placement="right">
                                <i className="fa fa-pencil fa-lg text-primary mr-2" />
                            </Tooltip>
                        </Link>
                        <Popconfirm
                            title="Are you sure to delete this box?"
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => onDelete(_id)}
                        >
                            <Tooltip title={`Delete`} placement="right">
                                <i className="fa fa-trash fa-lg text-danger" id={`TooltipDelete${item._id}`} />
                            </Tooltip>
                        </Popconfirm>
                    </td>
                </tr>
            }
            {type === 'split' && boxes_data && boxes_data.length > 0 &&
                boxes_data.map((i, index) => (
                    <tr key={`splitBox_${index}`} className={`rowSplitBox ${index > 0 ? 'topDashed' : ''}`}>
                        {index === 0 &&
                            <>
                                <td rowSpan={boxes_data.length}>
                                    <span className='font-weight-bold'>
                                        {shipping_carriers && shipping_carriers.length > 0 ?
                                            shipping_carriers.join(', ').toString()
                                            : '-'
                                        }
                                    </span>
                                </td>
                                <td rowSpan={boxes_data.length}><span className="text-capitalize">{type || '-'}</span> box</td>
                            </>
                        }
                        <td>{i.box_name || '-'}</td>
                        <td>{i.shipping_level ? shippingLevelCode[i.shipping_level] : 'All'}</td>
                        <td>{i.sku ? checkData(i.sku) : 'All'}</td>
                        {canViewStoreName && <td>{i.store ? checkData(i.store) : 'All'}</td>}
                        <td>{i.tag ? checkData(i.tag) : 'All'}</td>
                        <td>{i.state ? checkData(i.state) : 'All'}</td>
                        <td>{i.country ? checkData(i.country) : 'All'}</td>
                        {index === 0 &&
                            <>
                                <td rowSpan={boxes_data.length}>{updated_at ? moment(updated_at).format('HH:mm DD/MM/YYYY') : '-'}</td>
                                <td>
                                    <Link to={`/setting-boxes/${_id}`}>
                                        <Tooltip title={`Edit`} placement="right">
                                            <i className="fa fa-pencil fa-lg text-primary mr-2" />
                                        </Tooltip>
                                    </Link>
                                    <Popconfirm
                                        title="Are you sure to delete this box?"
                                        okText="Yes"
                                        cancelText="No"
                                        onConfirm={() => onDelete(_id)}
                                    >
                                        <Tooltip title={`Delete`} placement="right">
                                            <i className="fa fa-trash fa-lg text-danger" id={`TooltipDelete${item._id}`} />
                                        </Tooltip>
                                    </Popconfirm>
                                </td>
                            </>
                        }
                    </tr>
                ))
            }
        </>
    )
}

export default SettingBoxesRow